import LockClosed from 'atoms/Icons/LockClosed';
import Tooltip from 'atoms/Tooltip';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { OfferingItem } from 'stores/offeringUtils';
import { IInvestment, IOfferingInfo } from 'utils/globalTypes';
import { asParameterName } from 'utils/object';

import s from './BrowsingItemFooter.module.scss';

const BrowsingItemFooter = ({
  item,
  className,
  getFields,
  isGuestMode
}: {
  item: IOfferingInfo;
  className?: string;
  getFields?: (item: IInvestment) => OfferingItem[];
  isGuestMode?: boolean;
}) => {
  const fields = useMemo(() => getFields && getFields(item), [getFields, item]);

  return (
    <div className={cn(s.BrowsingItemFooter, className)}>
      {fields && (
        <div className={s.BrowsingItemFooter__items}>
          {fields?.map((field, index) => (
            <Tooltip key={`item-${index}`} title={field.description || ''} disableTouchListener>
              {isGuestMode ? (
                <div
                  className={cn(
                    s.BrowsingItemFooter__item,
                    { isGuestMode },
                    asParameterName(field.shortTitle)
                  )}
                >
                  <LockClosed className={s.BrowsingItemFooter__lock} />
                  <div className={s.BrowsingItemFooter__investmentSubtitle}>
                    {field.shortTitle || field.title}
                  </div>
                </div>
              ) : (
                <div className={cn(s.BrowsingItemFooter__item, asParameterName(field.shortTitle))}>
                  <strong className={cn(s.BrowsingItemFooter__label)}>
                    {field.range || field.value}
                  </strong>
                  <div className={s.BrowsingItemFooter__investmentSubtitle}>
                    {field.shortTitle || field.title}
                  </div>
                </div>
              )}
            </Tooltip>
          ))}
        </div>
      )}
    </div>
  );
};

export default observer(BrowsingItemFooter);
